// extracted by mini-css-extract-plugin
export default {"submitBtn":"DataAndInputContainer_submitBtn__3pgbk","addFileBtn":"DataAndInputContainer_addFileBtn__b-g3I"};